import { Alert, Button, Stack } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccountService } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { useDialogContext } from "../../../contexts/DialogContext";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { setStoreState } from "../silce/StoreSlice";
import PurchaseDialog from "./PurchaseDialog";

export default function InvoiceTypeDialog(props: { packageId: number; }) {
    const dialogContext = useDialogContext();
    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    const [isLoadingInfo, setIsLoadingInfo] = useState(false);

    const handleProceed = () => {
        dialogContext.closeDialog();
        dialogContext.openDialog(
            <PurchaseDialog
                hasRequestedInvoice={false}
                packageId={props.packageId}
            />
        );
    };

    const handleRedirectToAccountDetail = async () => {
        await fetchInvoiceInformation();
    };

    const fetchInvoiceInformation = async () => {
        try {
            setIsLoadingInfo(true);
            const info = await AccountService.getInvoiceInformation("1");

            if (!info) {
                dialogContext.closeDialog();
                navigate("/account-data");
                return;
            }

            dispatch(setStoreState(info));
            dialogContext.closeDialog();
            dialogContext.openDialog(
                <PurchaseDialog
                    hasRequestedInvoice={true}
                    packageId={props.packageId}
                />
            );
        } finally {
            setIsLoadingInfo(false);
        }
    };

    return (
        <DialogContainer>
            <DialogHeader title="انتخاب نوع فاکتور" />

            <Stack spacing={2} sx={{ p: 2 }}>
                <Alert severity="warning">
                    در فاکتور رسمی ۱۰ درصد هزینه ارزش‌افزوده اضافه خواهد شد.
                </Alert>

                <Button
                    variant="outlined"
                    color="warning"
                    onClick={handleProceed}
                >
                    فاکتور غیررسمی
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleRedirectToAccountDetail}
                    disabled={isLoadingInfo}
                >
                    فاکتور رسمی
                </Button>
            </Stack>
        </DialogContainer>
    );
}
